import axios from 'axios'
const instance = axios.create({
  timeout: 5000
})
const token = document.querySelector("meta[name='csrf-token']").getAttribute('content')
instance.defaults.headers.common['X-CSRF-TOKEN'] = token

export default {
  run(element){
    const link = element.querySelector("[data-close-job-target='link']")
    const modal = element.querySelector("[data-close-job-target='modal']")
    const cancelButton = element.querySelector("[data-close-job-target='cancelButton']")
    const okButton = element.querySelector("[data-close-job-target='okButton']")
    const url = element.getAttribute('data-close-job-url-value')
    const operation = (element.getAttribute('data-close-job-operation-value') == 'open')? false : true

    link.addEventListener('click', (e) => {
      e.preventDefault()
      $(modal).modal('show')
    })
    cancelButton.addEventListener('click', (e) => {
      e.preventDefault()
      console.log('canceled')
    })
    okButton.addEventListener('click', (e) => {
      e.preventDefault()
      $(modal).modal('hide')
      instance.patch(url, {
        job: {
          closed: operation
        }
      }).then(() => {
        location.reload()
      })
    })
  }
}